import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { ButtonV2 } from '@zola/zola-ui';

const ErrorModal = ({ buttonText, callback, hideModalFn, message, title }) => {
  const handleClose = useCallback(() => {
    hideModalFn();
    if (callback) {
      callback();
    }
  }, [callback, hideModalFn]);

  return (
    <>
      <div className="modal-header">
        <h2 className="modal-title">{title}</h2>
      </div>
      <div className="modal-body">
        <p className="text-left">{message}</p>
      </div>
      <div className="modal-footer">
        <ButtonV2 onClick={handleClose}>{buttonText || 'Done'}</ButtonV2>
      </div>
    </>
  );
};

ErrorModal.propTypes = {
  buttonText: PropTypes.string,
  callback: PropTypes.func,
  hideModalFn: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default ErrorModal;



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/ErrorModal/ErrorModal.jsx